import styled from "styled-components";
//components
import { Row } from 'components/Layout/Grid';
//interfaces
import { IDropdownArrow } from "./interface";


export const Container = styled(Row)<IDropdownArrow>`
  flex: 1;
  padding: 0.8em;
  min-width: 60px;
  height: 50px;
  align-items: center;
`